import React from 'react';
export const Impressum: React.FC = () => {
  return <div className="max-w-3xl mx-auto bg-gray-800 rounded-xl p-6 border border-gray-700 shadow-lg" data-id="element-252">
      <h1 className="text-2xl font-bold mb-6" data-id="element-253">Impressum</h1>
      <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-254">Angaben gemäß § 5 TMG</h2>
      <p data-id="element-255">
        INTIGOO! GmbH
        <br data-id="element-256" />
        Werner-von-Siemens-Straße 33
        <br data-id="element-257" />
        49124 Georgsmarienhütte
      </p>
      <p className="mt-3" data-id="element-258">
        <strong data-id="element-259">Handelsregister:</strong> HRB 217224
        <br data-id="element-260" />
        <strong data-id="element-261">Registergericht:</strong> Amtsgericht Osnabrück
      </p>
      <p className="mt-3" data-id="element-262">
        <strong data-id="element-263">Vertreten durch:</strong>
        <br data-id="element-264" />
        Fabian Kleine Huxel
        <br data-id="element-265" />
        Felix Höfelmeyer
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2" data-id="element-266">Kontakt</h2>
      <p data-id="element-267">
        <strong data-id="element-268">Telefon:</strong> +49 5401 1689580
        <br data-id="element-269" />
        <strong data-id="element-270">E‑Mail:</strong> info@intigoo.de
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2" data-id="element-271">Umsatzsteuer-ID</h2>
      <p data-id="element-272">
        <strong data-id="element-273">
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        </strong>
        <br data-id="element-274" />
        DE 349819653
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2" data-id="element-275">EU-Streitschlichtung</h2>
      <p data-id="element-276">
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:
        <a href="https://ec.europa.eu/consumers/odr/" className="text-blue-400 hover:text-blue-300 ml-1" target="_blank" rel="noopener noreferrer" data-id="element-277">
          https://ec.europa.eu/consumers/odr/
        </a>
        .<br data-id="element-278" />
        Unsere E‑Mail-Adresse finden Sie oben im Impressum.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2" data-id="element-279">
        Verbraucherstreitbeilegung / Universalschlichtungsstelle
      </h2>
      <p data-id="element-280">
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>;
};